<div [ngClass]="{'flex-box': vendor.type === VendorType.INDIVIDUAL}">
  <ng-container *ngIf="vendor.type === VendorType.INDIVIDUAL; else agencyLogo">
    <img
      [src]="vendor.logoMedia | mediaWithType: {auto: 'compress', fit: 'clip', fallback: '/assets/images/svg/user.png'}"
      alt="Agent"
      class="lender-logo"
    />
  </ng-container>
  <ng-template #agencyLogo>
    <img
      [src]="vendor.logoMedia | mediaWithType: {auto: 'compress', fit: 'clip', fallback: '/assets/images/svg/no_property_image_old.svg'}"
      alt="company"
      class="company-logo"
    />
  </ng-template>

  <div class="flex-item-auto-sizing">
    <ng-container *ngIf="vendor.type === VendorType.INDIVIDUAL">
      <h3 *ngIf="vendor.name" class="text-size-16 fw-600 m-0">{{ vendor.name }}</h3>
      <p *ngIf="vendor.companyName" class="text-color-light-2">{{ vendor.companyName }}</p>
      <p *ngIf="vendor.nmlsId" class="text-color-light-2">{{ vendor.nmlsId }}</p>
    </ng-container>
    <ng-container *ngIf="vendor.type === VendorType.COMPANY">
      <h3 *ngIf="vendor.companyName" class="text-size-16 fw-600 m-0">{{ vendor.companyName }}</h3>
      <p *ngIf="vendor.name" class="text-color-light-2">{{ vendor.name }}</p>
      <p *ngIf="vendor.nmlsId" class="text-color-light-2">{{ vendor.nmlsId }}</p>
    </ng-container>
    <span *ngIf="vendor.phone" class="text-color-grey-secondary grey mb-0 d-block">{{ vendor.phone | phone }}</span>
    <span *ngIf="vendor.email" class="text-color-grey-secondary text-overflow-ellipsis d-block mw-400">{{ vendor.email }}</span>
  </div>
</div>
